import { alertDialog } from './systemDialogs'
import { veraApi } from './api'
import { refreshProfileReferenceData } from './profileReferenceRefresh'

const clean = (value) => String(value || '').replace(/\s+/g, ' ').trim()
const CENTRAL_ISSUERS = [
  'Bộ Công an',
  'Cục Cảnh sát quản lý hành chính về trật tự xã hội, Bộ Công an',
  'Trung tâm dữ liệu quốc gia về dân cư, Cục Cảnh sát quản lý hành chính về trật tự xã hội, Bộ Công an',
  'Cục Cảnh sát đăng ký, quản lý cư trú và dữ liệu quốc gia về dân cư, Bộ Công an',
]
const CENTRAL_CITIES = new Set([
  'Hà Nội', 'Hải Phòng', 'Huế', 'Đà Nẵng', 'Cần Thơ', 'Hồ Chí Minh',
])

function normalizeProvinceName(value) {
  return clean(value).replace(/^Tỉnh\s+/i, '').replace(/^Thành phố\s+/i, '')
}

function profileRoots() {
  const roots = Array.from(document.querySelectorAll('.profile-form'))
  document.querySelectorAll('.staff-form-panel').forEach((panel) => {
    const title = clean(panel.querySelector('h2')?.textContent)
    if (title.startsWith('SỬA HỒ SƠ ·')) roots.push(panel)
  })
  return roots
}

function labelName(label) {
  return clean(label?.childNodes?.[0]?.textContent || label?.textContent)
}

function findLabel(root, wanted) {
  return Array.from(root.querySelectorAll('label')).find((label) => labelName(label).startsWith(wanted)) || null
}

function visibleOrSourceControl(label) {
  if (!label) return null
  return label.querySelector('[data-vera-issuer-source="1"]')
    || label.querySelector('[data-vera-national-source="1"]')
    || label.querySelector('input:not([type="file"]):not([type="password"]), select, textarea')
}

function currentFieldValue(root, labelText) {
  const label = findLabel(root, labelText)
  if (!label) return ''
  const source = label.querySelector('[data-vera-national-source="1"]')
  const select = label.querySelector('select[data-vera-national-select="1"], .vera-reference-row select')
  return clean(source?.value || select?.value || visibleOrSourceControl(label)?.value)
}


function policeAuthorityForProvince(name) {
  const raw = clean(name)
  const province = normalizeProvinceName(raw)
  if (!province) return ''
  const isCity = /^Thành phố\s+/i.test(raw) || CENTRAL_CITIES.has(province)
  return isCity ? `Công an thành phố ${province}` : `Công an tỉnh ${province}`
}

function localPoliceAuthority(wardName) {
  const ward = clean(wardName)
  return ward ? `Công an ${ward}` : ''
}

function issuerValues(catalogs, wards, currentValue = '') {
  const values = [
    ...CENTRAL_ISSUERS,
    ...(catalogs?.provinces || []).map((item) => policeAuthorityForProvince(item?.name)),
    ...(wards || []).map(localPoliceAuthority),
  ].filter(Boolean)
  const unique = Array.from(new Set(values))
  if (currentValue && !unique.includes(currentValue)) unique.unshift(currentValue)
  return unique
}

async function wardsForRoot(root, catalogs, refresh = false) {
  const provinceName = normalizeProvinceName(currentFieldValue(root, 'Tỉnh/Thành phố'))
  if (!provinceName) return []
  const province = (catalogs?.provinces || []).find((item) => normalizeProvinceName(item?.name) === provinceName)
  if (!province?.code) return []
  const data = refresh
    ? await refreshProfileReferenceData(province.code)
    : await veraApi.profileReferenceData(province.code)
  return data?.wards || []
}

function renderIssuerSuggestions(list, values) {
  const options = values.map(value => {
    const option = document.createElement('option')
    option.value = value
    return option
  })
  list.replaceChildren(...options)
}

let issuerListId = 0

function ensureStyles() {
  if (document.getElementById('vera-profile-completion-issuer-style')) return
  const style = document.createElement('style')
  style.id = 'vera-profile-completion-issuer-style'
  style.textContent = `
    .vera-issuer-wrap{display:grid;gap:6px}
    .vera-issuer-row{display:flex;gap:6px;align-items:center}
    .vera-issuer-row select{flex:1;min-width:0}
    .vera-issuer-refresh{min-height:36px;padding:0 9px;border:1px solid #b8c7c0;border-radius:8px;background:#fff;font-size:11px;font-weight:900;white-space:nowrap;cursor:pointer}
    .vera-issuer-refresh[disabled]{opacity:.55;cursor:wait}
    @media(max-width:700px){.vera-issuer-row{flex-direction:column;align-items:stretch}.vera-issuer-refresh{width:100%}}
  `
  document.head.appendChild(style)
}

async function enhanceIssuerRoot(root, force = false) {
  const label = findLabel(root, 'Nơi cấp')
  if (!label) return

  let source = label.querySelector('[data-vera-issuer-source="1"]')
  if (!source) {
    source = label.querySelector('input:not([type="file"]):not([type="password"]), textarea')
    if (!source) return
    source.dataset.veraIssuerSource = '1'
    source.style.display = ''
    source.setAttribute('placeholder', 'Chọn từ danh sách hoặc nhập Nơi cấp')
  }

  let wrap = label.querySelector('.vera-issuer-wrap')
  if (!wrap) {
    wrap = document.createElement('div')
    wrap.className = 'vera-issuer-wrap'
    const row = document.createElement('div')
    row.className = 'vera-issuer-row'
    const list = document.createElement('datalist')
    list.id = `vera-issuer-options-${++issuerListId}`
    list.dataset.veraIssuerOptions = '1'
    source.setAttribute('list', list.id)
    row.appendChild(list)
    wrap.appendChild(row)
    source.insertAdjacentElement('afterend', wrap)

    const button = document.createElement('button')
    button.type = 'button'
    button.className = 'vera-issuer-refresh'
    button.textContent = '↻ Cập nhật nơi cấp'
    button.addEventListener('click', async () => {
      if (button.disabled) return
      button.disabled = true
      const original = button.textContent
      button.textContent = 'Đang cập nhật…'
      try {
        await enhanceIssuerRoot(root, true)
      } catch (error) {
        (await alertDialog(`Không cập nhật được danh mục Nơi cấp: ${error?.message || 'lỗi không xác định'}`))
      } finally {
        button.disabled = false
        button.textContent = original
      }
    })
    row.appendChild(button)
  }

  const list = wrap.querySelector('datalist[data-vera-issuer-options="1"]')
  if (!list) return
  const catalogs = force ? await refreshProfileReferenceData() : await veraApi.profileReferenceData()
  let wards = []
  try { wards = await wardsForRoot(root, catalogs, force) } catch { wards = [] }
  renderIssuerSuggestions(list, issuerValues(catalogs, wards, clean(source.value)))
}

let scheduled = false
async function refreshUi() {
  for (const root of profileRoots()) {
    try { await enhanceIssuerRoot(root, false) } catch { /* Keep manual input usable if catalog fetch fails. */ }
  }
}

export function startEmployeeProfileCompletionAndIssuerFix() {
  if (window.__veraEmployeeProfileCompletionAndIssuerFixStarted) return
  window.__veraEmployeeProfileCompletionAndIssuerFixStarted = true
  ensureStyles()

  const schedule = () => {
    if (scheduled) return
    scheduled = true
    window.setTimeout(() => {
      scheduled = false
      void refreshUi()
    }, 80)
  }

  const observer = new MutationObserver(schedule)
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['title', 'class', 'value'],
  })
  document.addEventListener('input', schedule, true)
  document.addEventListener('change', schedule, true)
  document.addEventListener('click', schedule, true)
  schedule()
}
